<template>
<v-layout>
<v-flex md12>
<v-expansion-panel-content :data-cooperator-header="cooperator.id">
  <template v-slot:header>
  <div>
   <v-icon>account_circle</v-icon> {{cooperator.name || "Co-Operator #"+cooperator.id}}
     <span>
      <v-btn :data-btn="'delete-co-operator-'+cooperator.id" @click="deleteItem(cooperator)" flat icon color="red" align-end>
        <v-icon>delete</v-icon>
      </v-btn>
    </span>
  </div>
  </template>
<div :data-cooperator-index="cooperator.id">
  <v-text-field data-cooperator="name"
    v-model="cooperator.name" 
    label="Name" 
    required>
  </v-text-field>
  <v-text-field data-cooperator="address"
    v-model="cooperator.address" 
    label="Address" 
    required>
  </v-text-field>
    <v-text-field data-cooperator="city"
    v-model="cooperator.city" 
    label="City" 
    required>
  </v-text-field>
  <v-text-field data-cooperator="country"
    v-model="cooperator.country" 
    label="Country" 
    required>
  </v-text-field>
  <v-text-field data-cooperator="phone"
    v-model="cooperator.phone" 
    label="Phone" 
    required>
  </v-text-field>
  <v-text-field data-cooperator="email"
    v-model="cooperator.email" 
    label="Email" 
    required>
  </v-text-field>
</div>
</v-expansion-panel-content>
</v-flex>
</v-layout>
</template>

<script>
export default {
  data: () => ({}),
  props: ["cooperator"],
  computed: {},
  methods: {
    deleteItem(cooperator) {
      this.$emit("delete", cooperator);
    }
  }
};
</script>

<style>
</style>
